var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParaguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 0C9.6564 0 4.1754 3.69156 1.5874 9.0435H30.4121C27.8242 3.69156 22.3431 0 15.9998 0V0Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 31.9998C22.3431 31.9998 27.8242 28.3082 30.4122 22.9563H1.5874C4.1754 28.3082 9.6564 31.9998 15.9998 31.9998Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9351 11.369L18.4594 12.8446C19.0889 13.4741 19.4783 14.3436 19.4783 15.3042C19.4783 17.2252 17.921 18.7824 16 18.7824C14.0791 18.7824 12.5218 17.2251 12.5218 15.3042C12.5218 14.3436 12.9111 13.4741 13.5406 12.8446L12.0649 11.369C11.0577 12.376 10.4348 13.7673 10.4348 15.3042C10.4348 18.3778 12.9264 20.8693 16 20.8693C19.0736 20.8693 21.5652 18.3777 21.5652 15.3042C21.5651 13.7673 20.9423 12.376 19.9351 11.369V11.369Z",
    fill: "#6DA544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 13.2173L16.5184 14.8117H18.1947L16.8385 15.797L17.3565 17.3913L16.0003 16.406L14.644 17.3913L15.1621 15.797L13.8059 14.8117H15.4822L16.0003 13.2173Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaguay);
export default __webpack_public_path__ + "static/media/paraguay.6916478b.svg";
export { ForwardRef as ReactComponent };